import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidates puzzle scoreboard comment and like-count caches and refetches all matching queries
 * (including inactive ones) so notification navigation shows fresh data after remount.
 */
export function invalidatePuzzleScoreboardCaches(
    queryClient: QueryClient,
    playablePropertyId: string,
): void {
    void queryClient.invalidateQueries({
        queryKey: ["playable-property-comments", playablePropertyId],
        refetchType: "all",
    });
    void queryClient.invalidateQueries({
        queryKey: ["comment-like-counts", playablePropertyId],
        refetchType: "all",
    });
    void queryClient.invalidateQueries({ queryKey: ["comment-like-counts"], refetchType: "all" });
}
